export default __webpack_public_path__ + "static/IsabelAllendeonfindingjoyinchaos-927ea45e70604c117d323a1e48ea6ea0.jpg";